import Share from 'ninelines-sharing';

const init = () => {
	if (document.querySelector('[data-social]')) {
		const list = document.querySelectorAll('[data-social]');

		Array.prototype.forEach.call(list, (item) => {
			item.addEventListener('click', (e) => {
				let $test = $('.test');
				let shareWindow = Share.openWindow('');
				const social = e.currentTarget.dataset.social;

				let options = $.extend({
					url:    location.href,
					title:  document.title,
					image:  location.origin + '/images/share/share.jpg',
					text:   document.querySelector('meta[name="description"]').content,
				});

				let urlVK = 'http://vkontakte.ru/share.php?'
					+ 'url='          + encodeURIComponent(options.url)
					+ '&title='       + encodeURIComponent(options.title)
					+ '&description=' + encodeURIComponent(options.text)
					+ '&image='       + encodeURIComponent(options.image)
					+ '&noparse=true';

				console.log(urlVK);

				let url = location.origin + location.pathname;

				shareWindow.location = {
					facebook: `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
					vk: urlVK,
					twitter: `http://twitter.com/share?url=${encodeURIComponent(url)}`,
					ok: `https://connect.ok.ru/offer?url=${encodeURIComponent(url)}`,
				}[social];
			});
		});
	}
};

export default {
	init,
};
